export enum DeliverySource {
  LandingPage,
  Cmc,
  Printed,
  Cfs,
  Kiosk,
  Pos,
  Custom,
  Stand,
  SquareSticker,
  CircleSticker,
  NfcStand,
  NfcStickerRound,
  NfcStickerSquare,
  LeatherKeychain,
  NfcPvc,
  PhoneCard
}
